import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import db from '@/firebase/init';

const state = () => ({
  userdata: {
    locale: "en-gb",
    // locale: navigator.language || navigator.userLanguage,
  }
})

const getters = {
  getUserdata: (state) => () => {
    return state.userdata;
  }
}

const actions = {

  fetchUserdata(context) {
    let user = firebase.auth().currentUser;
    db.collection('userdata').doc(user.uid).get()
      .then((doc) => {
        if (doc.exists) {
          context.commit('setUserdata', doc.data());
          // TODO: merge with defaults (in case of new options)
        } else {
          // No userdata document ()
        }
      }).catch((error) => {
        console.log("Error getting userdata:", error);
      });
  },

  saveUserdata(context) {
    let user = firebase.auth().currentUser;
    let userdataDoc = context.getters.getUserdata();
    db.collection("userdata").doc(user.uid).set(userdataDoc)
      .then(() => {
          console.log("Userdata successfully saved!");
      })
      .catch((error) => {
          console.error("Error writing userdata: ", error);
      });
  },

}

const mutations = {

  setUserdata(state, userdata) {
    Vue.set(state, "userdata", userdata);
  },

  setUserdataField(state, {key, value}) {
    Vue.set(state.userdata, key, value);
  },

}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

